import Vactor from './Images/Frame27.svg';
import Vactor2 from './Images/vactor2.png';
import SwimingSupportMan1 from './Images/SwimingSupportMan1.png';
import SwimingSupportMan2 from './Images/SwimingSupportMan2.png';
import trainner1 from './Images/trainner1.png';
import trainner2 from './Images/trainner2.png';
import trainner3 from './Images/trainner3.png';
import trainner4 from './Images/trainner4.png';
import trainner5 from './Images/trainner5.png';
import event1 from './Images/event1.png' ;
import trainner6 from './Images/trainner6.png';
import BlueSea from './Images/blueSea.png';
import SwimmingCenter2 from './Images/outdoor10.png';
import SwimmingCenter1 from './Images/rita.jpg';
import SwimmingCenter3 from './Images/4T0A1305copy.jpg';
import GymWeight from './Images/gymWeight.png';
import Athelete from './Images/indoor2.png';
import SchoolGirl from './Images/schoolGirl.png';
import Lifegard from './Images/lifeguard.png';
import Package1 from './Images/package1.png';
import Package2 from './Images/package2.png';
import Package3 from './Images/package3.png';
import Package4 from './Images/package4.png';
import Package5 from './Images/package5.png';
import Package6 from './Images/package6.png';
import Package7 from './Images/package7.png';
import Package8 from './Images/package8.png';
import Package9 from './Images/package9.png';
import Package10 from './Images/package10.png';
import Package11 from './Images/package11.png';
import Package12 from './Images/package12.png';
import NEWS1 from './Images/news1.png';
import NEWS2 from './Images/news2.png';
import NEWS3 from './Images/news3.png';
import NEWS4 from './Images/news4.png';
import NEWS5 from './Images/news5.png';
import NEWS6 from './Images/news6.png';
import NEWS7 from './Images/news7.png';
import NEWS8 from './Images/news8.png';
import NEWS9 from './Images/news9.png';
import NEWS10 from './Images/news10.png';
import NEWS11 from './Images/news11.png';
import NEWS12 from './Images/news12.png';
import Frame236 from './Images/Frame 236.png';
import EVENTS1 from './Images/EVENTS1.png';
import EVENTS2 from './Images/EVENTS2.png';
import EVENTS3 from './Images/EVENTS3.png';
import EVENTS4 from './Images/EVENTS4.png';
import EVENTS5 from './Images/EVENTS5.png';
import EVENTS6 from './Images/EVENTS6.png';
import EVENTS7 from './Images/EVENTS7.png';
import EVENTS8 from './Images/EVENTS8.png';
import EVENTS9 from './Images/EVENTS9.png';
import EVENTS10 from './Images/EVENTS10.png';
import EVENTS11 from './Images/EVENTS11.png';
import EVENTS12 from './Images/EVENTS12.png';
import MEMBERSHIPBACKGROUND from './Images/MEMBERSHIPBACKGROUND.png';
import MEMBERSHIP1 from './Images/MEMBERSHIP1.png';
import MEMBERSHIP2 from './Images/MEMBERSHIP2.png';
import RESTURANTBACKGROUND from './Images/RESTURANTBACKGROUND.png';
import PerfBackground from './Images/PerfBackground.png';
import Performace1 from './Images/Performace1.png';
import Performace2 from './Images/Performace2.png';
import Performace3 from './Images/Performace3.png';
import Performace4 from './Images/Performace4.png';
import Relexation from './Images/Relexation.png';
import Contactimg1 from './Images/Contactimg1.png';
import CallIcon from './Images/CallIcon.png';
import LocationIcon from './Images/LocationIcon.png';
import MailIcon from './Images/MailIcon.png';
import Map from './Images/Map.png';
import FormImg from './Images/form-img.png';
import FooterLogo from './Images/footer-logo.png';
import OfferShkollaVeroreChildren from './Images/OfferShkollaVeroreChildren.jpg';
import OfferShkollaVeroreAdults from './Images/OfferShkollaVeroreAdults.jpg';
import OfferPakoIndividuale from './Images/OfferPakoIndividuale.jpg';
import OfferHyrjaDitore from './Images/OfferHyrjaDitore.jpg';

const Images = {
    Vactor,
    Vactor2,
    SwimingSupportMan1,
    SwimingSupportMan2,
    trainner1,
    trainner2,
    trainner3,
    trainner4,
    trainner5,
    trainner6,
    event1,
    BlueSea,
    SwimmingCenter2,
    SwimmingCenter1,
     SwimmingCenter3,
    GymWeight,
    Athelete,
    SchoolGirl,
    Lifegard,
    Package1,
    Package2,
    Package3,
    Package4,
    Package5,
    Package6,
    Package7,
    Package8,
    Package9,
    Package10,
    Package11,
    Package12,
    NEWS1,
    NEWS2,
    NEWS3,
    NEWS4,
    NEWS5,
    NEWS6,
    NEWS7,
    NEWS8,
    NEWS9,
    NEWS10,
    NEWS11,
    NEWS12,
  Frame236,
    EVENTS1,
    EVENTS2,
    EVENTS3,
    EVENTS4,
    EVENTS5,
    EVENTS6,
    EVENTS7,
    EVENTS8,
    EVENTS9,
    EVENTS10,
    EVENTS11,
    EVENTS12,
    MEMBERSHIPBACKGROUND,
    MEMBERSHIP1,
    MEMBERSHIP2,
    RESTURANTBACKGROUND,
    PerfBackground,
    Performace1,
    Performace2,
    Performace3,
    Performace4,
    Relexation,
    Contactimg1,
    CallIcon,
    LocationIcon,
    MailIcon,
    Map,
    FormImg,
    FooterLogo,
    OfferShkollaVeroreChildren,
    OfferShkollaVeroreAdults,
    OfferPakoIndividuale,
    OfferHyrjaDitore
}

export default Images;